/**
 * gift-card-addon.js — v2
 */

(function () {
  'use strict';

  var GIFT_CARD_HANDLE       = 'cards';
  var MESSAGE_FEE_VARIANT_ID = 53266235982131;
  var MESSAGE_PRICE_CENTS    = 150;

  /* ── QUEUE ── */
  var _queue   = [];
  var _running = false;

  function enqueue(fn) {
    _queue.push(fn);
    if (!_running) drain();
  }

  function drain() {
    if (!_queue.length) { _running = false; return; }
    _running = true;
    var fn = _queue.shift();
    Promise.resolve().then(fn).then(drain).catch(function (err) {
      console.error('[gift-card-addon]', err);
      drain();
    });
  }

  /* ── CART API ── */
  function apiPost(endpoint, body) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || r.statusText); });
      return r.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
           .then(function (r) { return r.json(); });
  }

  function cartAdd(payload) { return apiPost('/cart/add.js', payload); }

  /* ── HELPERS ── */
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function notifyCartUpdate() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  function setStatus(wrap, msg, isError) {
    var el = wrap.querySelector('.gca-status');
    if (!el) return;
    el.textContent = msg;
    el.style.color = isError ? '#c0392b' : '#2e7d32';
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.textContent = ''; }, 6000);
  }

  function setLoading(btn, isLoading) {
    var text    = btn.querySelector('.gca-add-btn__text');
    var spinner = btn.querySelector('.gca-add-btn__loading');
    btn.disabled = isLoading;
    if (text)    text.hidden    = isLoading;
    if (spinner) spinner.hidden = !isLoading;
  }

  /* ── CORE: add gift card + optional message ── */
  function addGiftCard(wrap, variantId, variantTitle, messageText) {
    var btn        = wrap.querySelector('.gca-add-btn');
    var hasMessage = messageText && messageText.trim().length > 0;

    setLoading(btn, true);

    return enqueue(function () {

      // Step 1: Add the gift card as a new line item every time
      var gcProperties = {
        '_addon':     'true',
        '_gc_design': variantTitle
      };
      if (hasMessage) {
        gcProperties['Gift Message'] = messageText.trim();
      }

      return cartAdd({ id: variantId, quantity: 1, properties: gcProperties })
        .then(function () {

          // Step 2: If message, add a new $1.50 message fee line item
          if (hasMessage && MESSAGE_FEE_VARIANT_ID) {
            return cartAdd({
              id: MESSAGE_FEE_VARIANT_ID,
              quantity: 1,
              properties: {
                '_addon':      'true',
                '_addon_type': 'message_fee',
                'Gift Message': messageText.trim()
              }
            });
          }

        })
        .then(function () {
          setLoading(btn, false);
          setStatus(wrap, '✓ Gift card added! Please refresh your cart to continue.', false);
          notifyCartUpdate();
        })
        .catch(function (err) {
          setLoading(btn, false);
          setStatus(wrap, err.message || 'Something went wrong — please try again.', true);
          throw err;
        });

    });
  }

  /* ── PRICE DISPLAY ── */
  function updatePriceDisplay(wrap, cardPriceCents, hasMessage) {
    var display = wrap.querySelector('.gca-price-value');
    if (!display) return;
    var total = cardPriceCents + (hasMessage ? MESSAGE_PRICE_CENTS : 0);
    display.textContent = money(total);
  }

  /* ── PANEL TOGGLE ── */
  function initToggle(wrap) {
    var toggleBtn = wrap.querySelector('.gca-toggle');
    var panel     = wrap.querySelector('.gca-panel');
    if (!toggleBtn || !panel) return;

    toggleBtn.addEventListener('click', function () {
      var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
      toggleBtn.classList.toggle('gca-toggle--open', !expanded);
    });
  }

  /* ── PER-WRAP INIT ── */
  function initWrap(wrap) {
    initToggle(wrap);

    var textarea = wrap.querySelector('.gca-message-textarea');
    var charCurr = wrap.querySelector('.gca-char-current');
    var addBtn   = wrap.querySelector('.gca-add-btn');

    if (textarea && charCurr) {
      textarea.addEventListener('input', function () {
        charCurr.textContent = textarea.value.length;
        var selectedRadio = wrap.querySelector('.gca-design-radio:checked');
        var cardPrice     = selectedRadio ? parseInt(selectedRadio.dataset.price, 10) : 200;
        updatePriceDisplay(wrap, cardPrice, textarea.value.trim().length > 0);
      });
    }

    wrap.addEventListener('change', function (e) {
      if (!e.target.matches('.gca-design-radio')) return;
      var cardPrice  = parseInt(e.target.dataset.price, 10) || 200;
      var hasMessage = textarea && textarea.value.trim().length > 0;
      updatePriceDisplay(wrap, cardPrice, hasMessage);
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var selectedRadio = wrap.querySelector('.gca-design-radio:checked');
        if (!selectedRadio) {
          setStatus(wrap, 'Please choose a card design first.', true);
          return;
        }
        var variantId    = parseInt(selectedRadio.value, 10);
        var variantTitle = selectedRadio.dataset.title || '';
        var message      = textarea ? textarea.value : '';
        addGiftCard(wrap, variantId, variantTitle, message);
      });
    }
  }

  /* ── INIT ── */
  function init() {
    document.querySelectorAll('.gca-wrap').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();